import { methodGet, methodPost, methodDelete, methodPut } from './methods';
import { API_INFO } from '../constants';
//NO USAR ESTOS ENDPOINDS NI ESTE ARCHIVO
export const getBooksOfTheMonth = async (id) => {
  const url = API_INFO + `libelista/books-month/${id}/`;
  return methodGet(url);
};
export const editBooksOfTheMonth = async (payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const url = API_INFO + `libelista/books-month/`;
  return methodPut(url, payload, config);
};
export const createBooksOfTheMonth = async (payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data;',
    },
  };
  const url = API_INFO + `libelista/books-month/`;
  return methodPost(url, payload, config);
};
export const deleteBooksOfTheMonth = async (id) => {
  const url = API_INFO + `libelista/books-month/${id}/`;
  return methodDelete(url);
};
export const getAllBooksOfTheMonth = async (query) => {
  const url = API_INFO + `libelista/books-month/`;
  return methodGet(url, query);
};
export const getBookOfTheMonthItem = async (id) => {
  const url = API_INFO + `libelista/book-month-items/${id}/`;
  return methodGet(url);
};
export const deleteBooksOfTheMonthItem = async (id) => {
  const url = API_INFO + `libelista/book-month-items/${id}/`;
  return methodDelete(url);
};
export const getAllBookOfTheMonthItems = async (query) => {
  const url = API_INFO + `libelista/book-month-items/`;
  return methodGet(url, query);
};
export const createBooksOfTheMonthItem = async (payload) => {
  const url = API_INFO + `libelista/book-month-items/`;
  return methodPost(url, payload);
};
export const editBooksOfTheMonthItem = async (id, payload) => {
  const url = API_INFO + `libelista/book-month-items/${id}/`;
  return methodPut(url, payload);
};

export const getLibraries = async (query) => {
  const url = API_INFO + `intranet/libraries/`;
  return methodGet(url, query);
};

export const getPostsCategories = async () => {               //! CAMBIAR EP
  return methodGet(API_INFO + 'libelista/posts/category/');
};

export const getBookComment = async (id) => {
  return methodGet(API_INFO + `products/comentarios/${id}/`);
};
export const editBookComment = async (payload) => {
  return methodPut(API_INFO + `products/comentarios/`, payload);
};
export const createBookComment = async (payload) => {
  return methodPost(API_INFO + `products/comentarios/`, payload);
};
export const getProductComments = async (query) => {
  const url = API_INFO + `products/comentarios/`;
  return methodGet(url, query);
};
export const deleteProductComment = async (commentId) => {
  return methodDelete(API_INFO + `products/comentarios/${commentId}`);
};

export const getPosts = async (query) => {                //! CAMBIAR EP
  return methodGet(API_INFO + 'libelista/posts/', query);
};

export const getBlogPosts = async (query) => {
  const url = API_INFO + `libelista/posts/all-posts/?${query}`;
  return methodGet(url);
};

export const getAssociatedList = async () => {
  return methodGet(API_INFO + `libelista/booklists/`);
};

export const createPost = async (payload) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPost(API_INFO + 'libelista/posts/', payload, config);
};
export const editPost = async (payload) => {
  return methodPut(API_INFO + `libelista/posts/`, payload);
};

export const getPost = async (id) => {                      //! CAMBIAR EP
  return methodGet(API_INFO + `libelista/posts/${id}/`);
};

export const deletePost = async (id) => {
  return methodDelete(API_INFO + `libelista/posts/${id}/`);
};

export const getAllClientMessages = async (query) => {
  const url = API_INFO + `libelista/customer_message/`;
  return methodGet(url, query);
};
export const getClientMessage = async (id) => {
  const url = API_INFO + `libelista/customer_message/${id}`;
  return methodGet(url);
};
export const deleteClientMessage = async (id) => {
  const url = API_INFO + `libelista/customer_message/${id}`;
  return methodDelete(url);
};
export const editClientMessage = async (payload) => {
  const url = API_INFO + `libelista/customer_message/`;
  return methodPut(url, payload);
};

export const getClientProfile = async () => {
  const url = API_INFO + 'libelista/libelista_user/';
  return methodGet(url);
};

export const getClientProfileById = async (id) => {
  return methodGet(API_INFO + `libelista/libelista_user/${id}/`);
};

export const putClientProfile = async (payload, id) => {
  const url = API_INFO + `libelista/libelista_user/${id}/`;
  return methodPut(url, payload);
};

export const postRegisterUser = async (payload) => {
  const url = API_INFO + 'libelista/libelista_user/';
  return methodPost(url, payload);
};

export const getActivityDetail = async (id) => {
  const url = API_INFO + `libelista/agenda/${id}/`;
  return methodGet(url);
};

export const getLibelistaLists = async (query) => {
  const url = API_INFO + `products/listas/`;
  return methodGet(url, query);
};

export const getLibelistaListDetail = async (id) => {
  const url = API_INFO + `libelista/booklists/${id}/`;
  return methodGet(url);
};

export const getLibelistaProducts = async (query) => {
  const url = API_INFO + `libelista/dashboard-books/`;
  return methodGet(url, query);
};

export const getLibelistaMainLists = async () => { //!ELIMINAR LIBELISTA EP
  const url = API_INFO + `libelista/booklists/main_lists/`;
  return methodGet(url);
};

export const getAllBooklists = async (query) => {
  const url = API_INFO + `libelista/booklists/`;
  return methodGet(url, query);
};

export const getAllBooklistsParents = async (query) => {
  const url = API_INFO + `libelista/booklists/get-all-booklists-parents/`;
  return methodGet(url, query);
};

export const getBookList = async (id, query) => {
  const url = API_INFO + `libelista/booklists/${id}/get-books/`;
  return methodGet(url, query);
};

export const deleteLibelistaList = async (id) => {
  const url = API_INFO + `libelista/booklists/${id}/`;
  return methodDelete(url);
};

export const postLibelistaList = async (payload) => {
  const url = API_INFO + 'libelista/booklists/';
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPost(url, payload, config);
};

export const editLibelistaList = async (payload, id) => {
  const url = API_INFO + `libelista/booklists/${id}/`;
  return methodPut(url, payload);
};

export const deleteSchedule = async (id) => {
  const url = API_INFO + `libelista/agenda/${id}`;
  return methodDelete(url);
};

export const postSchedule = async (payload) => {
  const url = API_INFO + 'libelista/agenda/';
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  return methodPost(url, payload, config);
};

export const editSchedule = async (payload) => {
  const url = API_INFO + `libelista/agenda/`;
  return methodPut(url, payload);
};

export const getScheduleDetail = async (id) => {
  const url = API_INFO + `libelista/agenda/${id}/`;
  return methodGet(url);
};

export const getTypeSchedule = async () => {
  const url = API_INFO + `libelista/agenda/tipo-agenda/`;
  return methodGet(url);
};
